import { SKY_WORLD, SKY_WORLD_ASSETS } from '../../../packages/domain/src/86-sky-world-scale.mjs';

/** Keep the actual pilot, supply decisions and complete robot in a close
 * shoulder view. Angular centering uses actual world coordinates, with at most
 *4.5m lens retreat; nothing is resized or moved to manufacture visibility.
 *119 injects its canonical perspective requirement, so projection has one owner.
 */
export function skyScrapCameraFrame(base, state, aspect, requiredFov) {
  const boss = state.boss,
    bounds = boss.authoredPose.bounds;
  const maximumFov = aspect < 0.5 ? 110 : 100;
  const frame = {
    ...base,
    x: state.x + (aspect < 1 ? 0.65 : 1.65),
    y: state.y + 1.5,
    z: (state.pilotZ ?? SKY_WORLD.pilotZ) + 5.85,
  };
  const sole = state.y - SKY_WORLD.pilotAimHeight;
  const points = [
    { x: state.x, y: sole, z: state.pilotZ ?? SKY_WORLD.pilotZ },
    { x: state.x, y: sole + SKY_WORLD_ASSETS.pilot.height, z: state.pilotZ ?? SKY_WORLD.pilotZ },
    ...boss.scrap.supplies
      .filter((pile) => pile.status === 'available')
      .map((pile) => boss.scrap.prop.authoredPose.sockets[pile.kind + '_supply']),
  ];
  for (const x of [bounds.min[0], bounds.max[0]])
    for (const y of [bounds.min[1], bounds.max[1]])
      for (const z of [bounds.min[2], bounds.max[2]]) points.push({ x, y, z });
  let required = 0;
  for (let attempt = 0; attempt < 10; attempt++) {
    const yaw = points.map((p) => Math.atan2(p.x - frame.x, frame.z - p.z));
    const pitch = points.map((p) =>
      Math.atan2(p.y - frame.y, Math.hypot(p.x - frame.x, frame.z - p.z)),
    );
    const middleYaw = (Math.min(...yaw) + Math.max(...yaw)) / 2;
    const middlePitch = (Math.min(...pitch) + Math.max(...pitch)) / 2;
    frame.lookX = frame.x + Math.sin(middleYaw) * Math.cos(middlePitch) * 50;
    frame.lookY = frame.y + Math.sin(middlePitch) * 50;
    frame.lookZ = frame.z - Math.cos(middleYaw) * Math.cos(middlePitch) * 50;
    required = Math.max(...points.map((point) => requiredFov(frame, point, aspect, 0.88)));
    if (required <= maximumFov || attempt === 9) break;
    frame.z += 0.5;
  }
  frame.fov = Math.max(aspect < 1 ? 64 : 56, Math.min(maximumFov, required));
  return frame;
}
